/**
 * 简体中文语言包
 *
 *
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
  * @create 2018-03-15
 */

const translations = {
  // 操作
  '提交': '提交',
  '提交开票信息': '提交开票信息',
  '返回': '返回',
  '关闭': '关闭',
  '保存': '保存',
  '保存并验真': '保存并验真',
  '确定': '确定',
  '上传': '上传',
  '取消': '取消',
  '编辑': '编辑',
  '编辑及验真': '编辑及验真',
  '报销': '报销',
  '打印': '打印',
  '删除': '删除',
  '登录': '登录',
  '获取验证码': '获取验证码',
  '获取': '获取',
  '绑定': '绑定',

  '选择发票抬头': '选择发票抬头',
  '使用微信抬头': '使用微信抬头',

  '查看发票': '查看发票',
  '查看票据': '查看票据',
  '下载发票': '下载发票',
  '发到邮箱': '发到邮箱',
  '复制发票链接': '复制发票链接',
  '放入卡包': '放入卡包',
  '添加抬头': '添加抬头',
  '添加标签': '添加标签',
  '更多信息': '更多信息',
  '更多操作': '更多操作',
  '推荐给朋友': '推荐给朋友',
  '设置标签': '设置标签',
  '清理缓存': '清理缓存',
  // 提示
  '标签管理小提示': '小提示:左滑列表可以编辑标签哦',
  '提示': '提示',
  '删除警告': '删除后无法恢复,确定要继续?',
  '长按下面文字复制': '长按下面文字复制链接',
  '加载完毕': '加载完毕',
  '加载中': '加载中',
  '加载失败': '加载失败',
  '没有任何记录': '没有任何记录',
  '本服务由票易通提供': '本服务由票易通提供,热线电话:400-630-4000',
  '必填': '必填',
  '选填': '选填',
  '操作成功': '操作成功',
  '删除成功': '删除成功',
  '修改成功': '修改成功',
  '长按识别二维码关注公众号并开票': '长按识别二维码关注公众号并开票',
  '开票成功提示': '亲爱的用户，您的开票申请已经提交成功，请近期留意开票结果。',
  '抬头上传成功提示': '抬头已上传成功，请耐心等待开票',

  '开票注意事项': '注：根据国家税务总局2017年第16号第二条规定，发票内容应该按照实际销售情况如实开具(仅提供明细开具).',
  '税号有误': '税号有误',
  '发票抬头长度小于100': '发票抬头长度小于100',

  '抬头信息': '抬头信息',
  '订单信息': '订单信息',
  '请准确填写抬头信息': '请准确填写抬头信息',
  '请准确填写收件人信息': '请准确填写收件人信息',
  '获取订单信息失败': '获取订单信息失败',
  '表单验证失败提示': '信息填写不完整或格式错误',
  '编辑增值税发票友情提示': '注：增值税发票、机动车销售统一发票只需编辑上面几项，其他信息在保存验真成功后会自动更新',

  '发票验真结果法律说明': '发票验真结果不作为法律依据，请以当地税务机关鉴定为准。',
  '该发票已通过国税局验真': '该发票已通过国税局验真',
  '该发票未验真': '该发票未验真',
  '该发票验真中': '该发票正在进行验真,请稍后查看验真结果',
  '保存成功': '保存成功',
  '保存失败': '保存失败',
  '提交成功': '提交成功',
  '编辑增值税发票保存成功': '票据信息保存成功，验真后自动更新其他信息，这可能需要几分钟的时间',
  '票据信息保存成功': '票据信息保存成功',

  '请输入手机号码': '请输入手机号码',
  '请输入收票邮箱': '请输入收票邮箱',
  '请输入邮箱': '请输入邮箱',
  '请输入抬头(必填)': '请输入抬头(必填)',
  '请输入手机号码(必填)': '请输入手机号码(必填)',
  '请输入收票邮箱(必填)': '请输入收票邮箱(必填)',

  '请选择发票抬头': '请选择发票抬头',
  '请选择抬头': '请选择抬头',
  '请输入抬头': '请输入抬头',

  '请输入购销方名称': '请输入购销方名称',
  '请输入验证码': '请输入验证码',

  '请输入标签名': '请输入标签名',
  '标签名已存在': '标签名已经存在',
  '标签名称过长': '标签名长度小于8',

  '10或12位': '10或12位数字或大写字母',
  '8位': '8位',
  '不含税': '不含税',
  '输入后6位': '输入后6位',

  '请选择票据分类': '请选择票据分类',
  '请输入车次': '请输入车次',
  '请输入航班': '请输入飞机航班号',
  '请选择始发地': '请选择始发地',
  '请选择到达地': '请选择到达地',
  '请选择出行日期': '请选择出行日期',
  '票据说明': '票据说明',
  '绑定手机邮箱提示': '为了您的发票安全，请绑定手机和收票邮箱',

  '请选择发票日期': '请选择发票日期',
  '票据影像不存在': '票据影像不存在',
  '已经被处理的票据不允许删除': '已经被处理的票据不允许删除',
  '验真成功或验真中的票据不允许编辑': '验真成功或验真中的票据不允许编辑',

  '手机号绑定成功': '手机号绑定成功',
  '手机号解除绑定成功': '手机号解除绑定成功',
  '验证码已发送,请注意查收': '验证码已发送,请注意查收',

  '手机号码未绑定': '手机号码未绑定',
  '收票邮箱未设置': '收票邮箱未设置',
  '请设置': '请设置',
  '未设置': '未设置',
  '解除绑定警告': '解绑后,您的票据安全将失去保障,确定要继续?',
  '文件提交成功': '文件提交成功',
  '增值税发票上传成功': '发票已放入我的票夹中，等待识别和验真.',
  '微信发票导入成功': '微信发票导入成功',
  '增值税发票拍照说明': '增值税专用发票、增值税普通发票、增值税电子普通发票、增值税电子普通发票(通行费)、增值税普通发票(卷票)等;',
  '其他票据拍照说明': '火车票、出租车票、飞机票、通讯费发票、银行收款凭证、定额发票、境外发票等；',
  '新城增值税发票拍照说明': "<p>拍摄增值税发票：</p>增值税专用发票、增值税普通发票、增值税电子普通发票、增值税电子普通发票（通行费）、增值税普通发票（卷票）等；<p>友情提示：增值税普通发票（卷票）仅可拍照采集，不能使用二维码采集。</p>",
  '新城其他票据拍照说明': '购方名称和税号若不符合，业务系统中将无法选到，请在 验真前仔细核对发票的购方名称和税号是否正确。',
  '扫发票二维码说明': '添加的发票无照片，如需保存图片请选择其他方式。',
  '正在进行图片预处理': '正在进行图片预处理',
  '正在上传文件': '正在上传文件',
  '发票影像列表是空的，无法上传': '发票影像列表是空的，无法上传',
  '共上传': '共上传',
  '个发票影像': '个发票影像',
  '无': '无',
  '请输入名称': '请输入名称',
  '该终端不支持扫一扫功能': '该终端不支持扫一扫功能',
  '已被他人保存': '此发票已被他人占用，无法报销',
  '货物运输到达地选择': '货物运输到达地选择',

  // 页面名称  栏目标题
  // '增值税专用发票':'增值税专用发票',
  // '增值税普通发票':'增值税普通发票',
  // '增值税普通发票(农产品)':'增值税普通发票(农产品)',
  // '增值税电子普通发票':'增值税电子普通发票',
  // '增值税普通发票(卷票)':'增值税普通发票(卷票)',
  // '普通发票':'普通发票',
  // '机动车销售统一发票':'机动车销售统一发票',
  // '飞机票':'飞机票',
  // '火车票':'火车票',
  // '出租车票':'出租车票',
  // '通讯发票':'通讯发票',

  '票税助手': '票税助手',
  '订单发票': '订单发票',
  '发票影像': '发票影像',
  '拍发票': '拍发票',
  '票据详情': '票据详情',
  '标签管理': '标签管理',

  '导入微信发票': '导入发票',
  '共': '共',
  '张票据，累计金额': '张票据，累计金额',
  '即将开通，敬请期待': '即将开通，敬请期待',
  '选取发票失败': '选取发票失败',
  '取消选取发票': '取消选取发票',

  '抬头管理': '抬头管理',
  '开户行': '开户行',
  '发票号码': '发票号码',
  '发票代码': '发票代码',
  '您要添加哪种票据': '您要添加哪种票据?',
  '拍照技巧': '拍照技巧',
  '上传发票PDF': '上传发票PDF',
  '上传发票': '上传发票',
  '确定上传发票': '确定上传发票',
  '扫发票二维码': '扫发票二维码',
  '帮助中心': '帮助中心',
  '个人中心': '个人中心',
  '关于我们': '关于我们',
  '绑定手机': '绑定手机',
  '绑定邮箱': '绑定邮箱',
  '隐私协议': '隐私协议',
  '设置收票邮箱': '设置收票邮箱',
  '重新绑定手机': '重新绑定手机',
  '解除绑定': '解除绑定',
  '登录票税助手': '登录票税助手',
  '验证码': '验证码',
  '订单号': '订单号',
  '订单金额': '订单金额',
  '订单日期': '订单日期',
  '发票日期': '发票日期',
  '发票金额': '发票金额',
  '发票详情': '发票详情',
  '编辑发票': '编辑发票',
  '不含税金额': '不含税金额',
  '税额': '税额',
  '含税金额': '含税金额',
  '新增标签': '新增标签',
  '新增票据': '新增票据',
  '编辑票据': '编辑票据',
  '新增发票': '新增发票',
  '上传抬头': '上传抬头',

  '增值税发票': '拍摄增值税发票',
  '其他票据': '拍摄其他票据',

  '抬头类型': '抬头类型',
  '企业': '企业',
  '个人或政府机构': '个人/政府机构',
  '发票类型': '发票类型',
  '发票状态': '发票状态',
  '电子发票': '电子发票',
  '纸质发票': '纸质发票',
  '抬头': '抬头',
  '发票抬头': '发票抬头',
  '税号': '税号',
  '手机号码': '手机号码',
  '手机号': '手机号',
  '邮箱': '邮箱',
  '收票邮箱': '收票邮箱',
  '地址': '地址',
  '电话': '电话',
  '电话号码': '电话号码',
  '企业地址': '企业地址',
  '开户银行': '开户银行',
  '银行账号': '银行账号',
  '费用': '费用',
  '元': '元',

  '开具发票': '开具发票',
  '二维码开票': '二维码开票',
  '关注公众号': '关注公众号',
  '增值税电子普通发票': '增值税电子普通发票',
  '销售方': '销售方',
  '购买方': '购买方',

  '新增抬头': '新增抬头',
  '编辑抬头': '编辑抬头',
  '抬头详情': '抬头详情',

  '默认抬头': '默认抬头',
  '默认': '默认',
  '设为默认': '设为默认',

  '报销发票': '报销发票',
  '已开发票': '已开发票',
  '我的票夹': '我的票夹',
  '票夹': '票夹',
  '发票验真': '发票验真',
  '发票归集': '发票归集',

  '分类': '分类',
  '类型': '类型',
  '状态': '状态',
  '日期': '日期',
  '归集日期': '归集日期',
  '校验码': '校验码',

  '查看验真结果': '查看验真结果',
  '查看验真失败原因': '查看验真失败原因',
  '标签': '标签',
  '管理标签': '管理标签',
  '商品明细': '商品明细',
  '名称': '名称',
  '金额': '金额',
  '税率': '税率',
  '金额/税率': '金额/税率',
  '上拉加载更多': '上拉加载更多',
  '下拉刷新': '下拉刷新',
  '松开加载': '松开加载',
  '松开刷新': '松开刷新',
  '备注': '备注',
  '发票备注': '发票备注',
  '个人备注': '个人备注',
  '始发地': '始发地',
  '到达地': '到达地',
  '从': '从',
  '到': '到',
  '上车时间': '上车时间',
  '下车时间': '下车时间',
  '出行日期': '出行日期',
  '车次': '车次',
  '航班': '航班',
  '票据信息': '票据信息',

  '服务电话': '服务电话',
  '服务邮箱': '服务邮箱',

  // 状态
  '已报销': '已报销',
  '报销中': '报销中',
  '未报销': '未报销',

  '待识别': '待识别',
  '识别中': '识别中',
  '识别完成': '识别完成',
  '识别失败': '识别失败',

  '验真成功': '验真成功',
  '验真失败': '验真失败',
  '待验真': '待验真',
  '验真中': '验真中',

  '验签成功': '验签成功',
  '验签失败': '验签失败',
  '无法验签': '无法验签',
  '验签中': '验签中',
  '该发票验签中': '该发票验签中',
  '该发票通过电子签章验证': '该发票通过电子签章验证',
  '请上传PDF/OFD文件，图片或复印件无法验签': '请上传PDF/OFD文件，图片或复印件无法验签。',
  '该发票无法通过电子签章验证，请您重新上传原始PDF/OFD文件识别，请勿上传截图、PDF转图片、复印件等': '该发票无法通过电子签章验证，请您重新上传原始PDF/OFD文件识别，请勿上传截图、PDF转图片、复印件等。',


  // 物流信息
  '纸质发票邮寄地址': '纸质发票邮寄地址',
  '收件人': '收件人',
  '联系电话': '联系电话',
  '所在地区': '所在地区',
  '详细地址': '详细地址',
  '电话有误': '电话有误',
  '请使用微信或支付宝开票': '请使用微信或支付宝开票',
  '订单异常，无法开票，请联系开票员': '订单异常，无法开票，请联系开票员',
  '门店号': '门店号',
  '纸质专票': '纸质专票',
  '小票已申请开票，请勿重复申请': '小票已申请开票，请勿重复申请',
  '房间号': '房间号',
  '姓名': '姓名',
  '更新日期': '更新日期',
  '工作流号': '工作流号',
  '报销金额': '报销金额',

  '发票开具成功': '发票开具成功',
  '该发票已被他人领取': '发票已开具',
  '发票开具中': '发票开具中',
  '发票申请成功提示': '1.电子发票将于24-48小时内完成开具。开具成功后，您将收到消息通知。',
  '纸质发票申请成功提示': '2.纸质发票，请以发票邮寄为准。',
  '已被他人开具提示': '此票据已成功开具过发票，不可重复开票',
  '开票申请提交成功': '开票申请提交成功',
  '查看开票状态': '查看开票状态',

  '所属集团': '所属集团',
  '集团信息': '集团信息',
  '集团名称': '集团名称',
  '请输入您所在集团的全称': '请输入您所在集团的全称',
  '个人工号': '个人工号',
  '请输入您的个人工号': '请输入您的个人工号',
  '以上信息仅作为公司系统接入时发票抽取凭证': '以上信息仅作为公司系统接入时发票抽取凭证',
  '本功能仅限合作商户使用': '本功能仅限合作商户使用',
  '集团绑定成功': '集团绑定成功',
  '集团名称不能超过200位': '集团名称不能超过200位',
  '个人工号不能超过20位': '个人工号不能超过20位',
  '扫二维码添加的发票无照片！如须保存照片，请选择其他方式': '扫二维码添加的发票无照片！如须保存照片，请选择其他方式',
  '已占用': '已占用',
  '填写2项数据，可完成绑定；清空2项数据，可完成解绑': '填写2项数据，可完成绑定；清空2项数据，可完成解绑',

  '已完成': '已完成',
  '开票中': '开票中',
  '月份': '月份',
  '开票状态': '开票状态',
  '请填写正确的邮箱': '请填写正确的邮箱',
  '邮件发送成功': '邮件发送成功',
  '邮件发送失败，请稍后重试': '邮件发送失败，请稍后重试',
  '自动计算': '自动计算',
  '发票申请': '发票申请',
  '发票查询': '发票查询',
  '请填写小票号': '请填写小票号',
  '请填写订单金额': '请填写订单金额',
  'PDF下载链接已复制到粘贴板': 'PDF下载链接已复制到粘贴板',
  'PDF下载链接复制到粘贴板失败，请选择邮件发送': 'PDF下载链接复制到粘贴板失败，请选择邮件发送',
  '非企业性单位': '非企业性单位',
  '小票TC号': '小票TC号',
  '请填写收银小票的TC号': '请填写小票TC号',
  '小票金额': '小票金额',
  '请填写收银小票的金额': '请填写小票金额',
  '如何查找TC号': '如何查找TC号',
  '小票订单号': '小票订单号',
  '请填写小票订单号': '请填写小票订单号',
  '如何查找小票订单号': '如何查找小票订单号',
  '查看示例': '查看示例',
  '授权管理': '授权管理',
  '申请开票': '申请开票',
  '上传票据': '上传票据',
  '个人': '个人',
  'BP岗': 'BP岗',
  '报销类型': '报销类型',
  '提交警示': '提交后无法修改标签，请确认是否立即提交',
  '已退回': '已退回',
  '退回原因': '退回原因',
  '未找到订单信息': '未找到订单信息',
  '开票失败': '开票失败！详情请咨询相关门店或拨打小票客服电话申请开票！',
  '重扫二维码提示': '3.退出此界面后，如需查看开票状态，请重新扫描小票二维码',
  '关注官方公众号1': '长按识别二维码即刻关注',
  '关注官方公众号2': '官方微信并解锁更多惊喜',
  '未打标签的发票不能提交': '未打标签的发票不能提交',
  '已抽取的发票不能删除': '已抽取的发票不能删除',
  '已提交的发票不能重新编辑标签': '已提交的发票不能重新编辑标签',
  '不能重复提交': '不能重复提交',
  '欢迎使用票税助手': '欢迎使用票税助手',
  '开户银行和银行账号必须同时填写': '开户银行和银行账号必须同时填写',

  '完成': '完成',
  '第一步：绑定集团信息': '第一步：绑定集团信息',
  '第二步：绑定个人信息': '第二步：绑定个人信息',
  '第三步：绑定PC端': '第三步：绑定PC端',
  '去扫码': '去扫码',

  '同意': '同意',
  '不同意': '不同意',
  '请先阅读并勾选用户隐私协议': '请先阅读并勾选用户隐私协议',
  "发票上传": '发票上传',
  "附件上传": '附件上传'
}
export default translations
